import React, { useState } from 'react';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Card, CardContent, Divider, Grid2, Typography } from '@mui/material';
import ImportMethodSelector from './ImportMethodSelector';
import NewRequestForm from './NewRequestForm';
import UpdateRequestForm from './UpdateRequestForm';
import DeleteRequestForm from './DeleteRequestForm';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3)
	},
	content: {
		marginTop: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(3),
	}
}));

const StepIn = () => {
	const classes = useStyles();
    
	const [importMethod, setImportMethod] = useState('invalid');

	const handleImportMethodChange = (method) => {
		setImportMethod(method);
	};
    
	return (
		<Grid2 container spacing={2}>						
			<Grid2 item size={12}>
				<div className={clsx(classes.container)}>
					<ImportMethodSelector onChange={handleImportMethodChange} value={importMethod} />
				</div>
			</Grid2>
			<Grid2 item size={12}>
				{importMethod !== 'invalid' && (
					<Card className={classes.content}>
						<CardContent>	
							<Grid2 item size={12}>
								<Typography align="center" variant="h4" gutterBottom component="div">
									{importMethod === '1' && "New Request"}
									{importMethod === '2' && "Delete Request"}
									{importMethod === '3' && "Update Request"}
								</Typography>
							</Grid2>
							<div className={clsx(classes.container)}>
								{importMethod === '1' && (<NewRequestForm />)}
								{importMethod === '2' && (<DeleteRequestForm />)}
								{importMethod === '3' && (<UpdateRequestForm />)}
							</div>
						</CardContent>	
					</Card>		
				)}					
			</Grid2>						
		</Grid2>
	);
};

export default StepIn;